<template>
  <div class="container-fluid d-flex justify-content-center align-items-center flex-column w-100 alert">
    <div class="d-flex mb-3 mt-3">
      <i class="fa-solid fa-exclamation-triangle text-warning display-4"></i>
    <h4 class="display-4 text-center ms-2">Alerta cambio Mora</h4>
    </div>

    <!-- <button class="btn btn-primary mb-3" @click="enviarCorreo()" style="color: white;">
      <i class="fa-solid fa-envelope"></i>
      Enviar correo a asesores
    </button> -->

    <div v-if="creditosCombinados.length" class="tabla-scrollable w-100">
      <table class="table table-hover tabla-con-encabezado">
        <thead>
          <tr>
            <th>Beneficiario</th>
            <th class="text-center">Días de Mora</th>
            <th class="text-end">Saldo Adeudado</th>
            <th>Asesor</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="credito in creditosCombinados"
            :key="credito.id"
            :class="claseFila(credito)"
            @click="irCredito(credito.cliente.dni)"
            style="cursor: pointer;"
          >
            <td>{{ credito.cliente.nombres }} {{credito.cliente?.apellidos}}</td>
            <td class="text-center">{{ credito.diasMora }}</td>
            <td class="text-end">{{ formatoNumero(totalAdeudado(credito)) }} {{ moneda }}</td>
            <td>{{ credito.nombreAsesor }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="alert alert-warning text-center" role="alert">
        <i class="fa-solid fa-check-circle"></i>
        <strong class="ms-2">No hay créditos con cambio de mora</strong>
        
    </div>
  </div>
</template>

<script>
export default {
  name: 'TablaCreditosUnificada',
  props: {
    creditos1: { type: Array, default: () => [] },
    creditos31: { type: Array, default: () => [] },
    creditos61: { type: Array, default: () => [] },
    creditos90: { type: Array, default: () => [] }
  },
  data() {
    return {
      moneda: 'Lps'
    }
  },
  computed: {
    creditosCombinados() {
      const agregarMora = (lista, dias) =>
        Array.isArray(lista) ? lista.map(c => ({ ...c, diasMora: dias })) : []

      return [
        ...agregarMora(this.creditos1, 1),
        ...agregarMora(this.creditos31, 31),
        ...agregarMora(this.creditos61, 61),
        ...agregarMora(this.creditos90, 90)
      ]
    }
  },
  methods: {
    formatoNumero(n) {
      return new Intl.NumberFormat('es-HN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(n)
    },
    totalAdeudado(credito) {
      return (
        (credito.saldo || 0) +
        (credito.simularPagoHoy?.saldoInteres || 0) +
        (credito.simularPagoHoy?.saldoMora || 0)
      )
    },
    irCredito(dni) {
      this.guardarEnLocalStorage('busqueda', dni)
      window.location.href = '/cartera'
    },
    guardarEnLocalStorage(clave, valor) {
      try {
        localStorage.setItem(clave, JSON.stringify(valor))
      } catch (e) {
        console.error('No se pudo guardar en localStorage:', e)
      }
    },
    claseFila(credito) {
      switch (credito.diasMora) {
        case 1: return 'table-alerta-1'
        case 31: return 'table-alerta-31'
        case 61: return 'table-alerta-61'
        case 90:
        default: return 'table-alerta-90'
      }
    },
    // enviarCorreo(){
    //   // Lógica para enviar correo a asesores
    //   fetch(process.env.VUE_APP_API_URL + "/admin/credito/enviar-correo", Security.requestOptions({ destinatario: 'notificaciones@axcc.local', asunto: "Mensaje Prueba", mensaje: "Prueba" }))
    //     .then((response) => response.json())
    //     .then((response) => {
    //       if (response.error) {
    //         this.$emit('error', response.message);

    //         console.error(response.message)
    //       } else {

         


    //         console.log('Dashboard data loaded successfully:', response);

    //       }
    //     })
    //     .catch(error => {
    //       this.$emit('error', error)
    //     })

    // },
  }
}
</script>

<style scoped>

/* Estilos por alerta */
.table-alerta-1 {
  background-color: var(--color-alerta-leve) !important;
  color: #212529;
}

.table-alerta-31 {
  background-color: var(--color-alerta-media) !important;
  color: #212529;
}

.table-alerta-61 {
  background-color: var(--color-alerta-grave) !important;
  color: #212529;
}

.table-alerta-90 {
  background-color: var(--color-alerta-critica) !important;
  color: #212529;
}

/* Scroll y encabezado fijo */
.tabla-scrollable {
  max-height: 500px;
  overflow-y: auto;
  border: 1px solid #dee2e6;
}

.tabla-con-encabezado thead th {
  position: sticky;
  top: 0;
  background-color: #f8f9fa;
  z-index: 1;
}

@media (max-width: 767px) {
  .container {

    padding: 0px;

  }
}

.alert{
  padding: 0px;
  /* font-size: 12px; */
}

td, th {
  margin: 0px;
  font-size: 10px !important;
}
</style>

<style>
:root {
  --color-alerta-leve: #ffff70;     /* Amarillo */
  --color-alerta-media: #ffb67a;    /* Naranja */
  --color-alerta-grave: #ff9d7a;    /* Rojo claro */
  --color-alerta-critica: #ff6767;  /* Gris oscuro */
}
</style>
